import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router ({
  // mode: 'history',
  // base: 'wx',
  routes:[
    {
      path: '/cellPrePay',
      name: 'cellPrePay',
      component: resolve=>require(["../page/tool/cellPrePay.vue"],resolve)
    },
  ]
})
